<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 14.6667 14.6667"
    fill="none"
    aria-hidden="true"
    class="g-icon-arrow-circle-right"
  >
    <path d="M13.3333 7.33333C13.3333 4.01963 10.647 1.33333 7.33333 1.33333C4.01963 1.33333 1.33333 4.01963 1.33333 7.33333C1.33333 10.647 4.01963 13.3333 7.33333 13.3333C10.647 13.3333 13.3333 10.647 13.3333 7.33333ZM6.66797 4.01563C6.92832 3.75528 7.35098 3.75528 7.61133 4.01563L10.457 6.86198C10.582 6.987 10.6523 7.15653 10.6523 7.33333C10.6523 7.51013 10.582 7.67967 10.457 7.80469L7.61133 10.651C7.35099 10.9114 6.92832 10.9114 6.66797 10.651C6.40762 10.3907 6.40762 9.96803 6.66797 9.70768L8.3763 8H4.99935C4.63118 7.99998 4.33269 7.70151 4.33268 7.33333C4.33268 6.96516 4.63117 6.66669 4.99935 6.66667H8.3763L6.66797 4.95833C6.40788 4.69797 6.40773 4.27589 6.66797 4.01563ZM14.6667 7.33333C14.6667 11.3834 11.3834 14.6667 7.33333 14.6667C3.28325 14.6667 3.57628e-07 11.3834 0 7.33333C2.5723e-08 3.28325 3.28325 3.57628e-07 7.33333 0C11.3834 2.57231e-08 14.6667 3.28325 14.6667 7.33333Z" fill="currentColor" />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 16
})
</script>

<style scoped>
.g-icon-arrow-circle-right {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
